import {Redirect, Route} from "react-router-dom";
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";

import {getMe, isLoggedIn} from "../store/slices/auth";
import Loading from "../components/Common/Loading";
import {Box} from "@material-ui/core";

import {firebaseMessaging, getToken} from '../utils/firebase';
import {addNotificationCount} from "../store/slices/notification";
import AppConfig, { SYSTEM_ROLE } from "config/AppConfig";
import StorageHelper from "utilities/StorageHelper";
const { STORAGE_KEYS } = AppConfig;
const PrivateRoute = ({component: Component, ...rest}) => {
    const dispatch = useDispatch();
    const loggedIn = useSelector(isLoggedIn) || false;
    const [loading, setLoading] = useState(loggedIn);
    const [userInfo, setUserInfo] = useState(StorageHelper.getLocalObject(STORAGE_KEYS.user) || {});

    const loadUser = async () => {
        const result = await dispatch(getMe());
        const { payload } = result;
        if (payload) {
            setUserInfo(payload);
        }
        setLoading(false);
    };

    if(firebaseMessaging !== null) {
        firebaseMessaging.onMessage((payload) => {
            console.log("onMessage", payload);
            dispatch(addNotificationCount());
        });
    }

    useEffect(() => {
        if (loggedIn) {
            loadUser();
        }
    }, [loggedIn]);

    useEffect(() => {
        getToken();
    }, [])

    if (loading) {
        return (
            <Box>
                <Loading/>
            </Box>
        );
    }

    return (
        <Route
            {...rest}
            render={(props) => {
                if (loggedIn) {
                    return <Component path={rest.path} {...props} />;
                    // if (
                    //     rest.path.includes("/admin")
                    //     // &&
                    //     // user &&
                    //     // user.roleId === AppConfig.USER_ROLES.ADMIN
                    // ) {
                    //   return <Component path={rest.path} {...props} />;
                    // } else {
                    //   return (
                    //       <Redirect
                    //           to={{
                    //             pathname: "/home",
                    //             state: { from: props.location },
                    //           }}
                    //           push
                    //       />
                    //   );
                    // }
                }
                return (
                    <Redirect
                        to={{
                            pathname: rest.path.includes("/admin") ? userInfo.role === SYSTEM_ROLE.COMPANY ? "/auth/company/login" : "/auth/login" : 
                            (userInfo.role === SYSTEM_ROLE.NURSE || userInfo.role === SYSTEM_ROLE.SUPPORT_WORKER) ?
                            "/auth/worker/login" : "/auth/company/login",
                            state: {from: props.location},
                        }}
                        push
                    />
                );
            }}
        />
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.any,
    path: PropTypes.any,
    location: PropTypes.object,
};

export default PrivateRoute;
